<template>
  <span :class="elem.classes" :title="elem.content" v-b-tooltip.hover>
    <i :class="elem.icon"></i>
  </span> 
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    // Elements
    elem() {
      return { 
        classes: {
          'text-hint': true,
          'cursor-pointer': true,
        },
        icon: "far fa-question-circle fs-16",
        content: this.message,
      };
    },
  },
}
</script>
